<p-confirmDialog [style]="{ width: '450px' }" />

<p-toolbar styleClass="mb-4 gap-2 top-action-bar" [style]="{'z-index': '2'}">
    <ng-template pTemplate="left">
        <div class="flex align-items-center gap-2">

        </div>
    </ng-template>

    <ng-template pTemplate="right">
        <div class="flex align-items-center gap-2">
            <p-button label="Import Data" icon="pi pi-upload" severity="success" (onClick)="showImportDialog()" />
        </div>
    </ng-template>
</p-toolbar>

<p-table [value]="data" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="req.pageSize"
    [first]="req.page" [showCurrentPageReport]="true" [rowHover]="true" dataKey="id" lazy="true" [totalRecords]="total"
    (onLazyLoad)="loadDataLazy($event)" [scrollable]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

    <ng-template #caption>
        <div style="display: flex; justify-content: space-between;">
            <h3 class="m-0">Manage Accounting Tabs</h3>
        </div>
    </ng-template>

    <ng-template #header>
        <tr>
            <th>Date</th>
            <th>Total Items</th>

            <th></th>
        </tr>
    </ng-template>
    <ng-template #body let-item>
        <tr>
            <td>{{ item.date | date: 'dd/MM/yyyy' }}</td>
            <td>{{ item.totalEntries }}</td>
            <td>
                <div class="flex flex-row gap-2">
                    <a [href]="'/accounting/tabs/' + formatDate(item.date)">View</a>
                    <a style="color: red" (click)="deleteDate($event, item.date)" href="#">Delete</a>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Import data from Excel" [modal]="true" [(visible)]="importDialogVisible" [style]="{ width: '500px' }">
    <div class="flex flex-column gap-4 mt-4 mb-8">
        <div class="p-field flex flex-column gap-2">
            <label>Date</label>
            <p-datepicker [(ngModel)]="date" appendTo="body" dateFormat="dd/mm/yy" />
        </div>

        <div class="p-field flex flex-column gap-2">
            <label>Excel File</label>
            <p-fileupload #fu mode="basic" chooseLabel="Choose" chooseIcon="pi pi-upload" name="excel[]" accept=".xlsx"
                customUpload="true" maxFileSize="1000000" (uploadHandler)="onUpload($event)" />
        </div>
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" severity="secondary" (click)="importDialogVisible = false" />
        <p-button label="Import" (click)="submitUpload()" />
    </div>
</p-dialog>

<p-dialog [(visible)]="nowLoadingModal" [modal]="true" header="Please wait" [closable]="false">

    <div class="flex" style="align-items: center; gap: 20px">
        <div>
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
        <p>Parsing excel. Please wait</p>
    </div>

</p-dialog>